<template>
    <div v-if="active" class="card">        
        <a class="theme-primary help-icon icon text-right" href="login-help.html" target="_blank" alt="Login Help">
            <fa-icon :icon="['fas','question-circle']" /><span class="sr-only">login help</span>
        </a>
        <Error ref="error" />
        <div class="card-body" @keyup.enter="submitAddMethod">
            <PageHeader :title="title" variant="small" class="mb-4" />
            <h3 class="h5">{{screenData.text.twoFactor}}</h3>
            <div class="form-group">
                <label for="securityMethod">{{screenData.text.addMethod}}</label>
                <select id="securityMethod" class="form-control" v-model="deliveryMethod">
                    <option value="1">{{screenData.text.mobile}}</option>
                    <option value="2">{{screenData.text.email}}</option>
                </select>
            </div>
            <MultiFactorPhoneNumber v-if="isMobileMethod" :labels="screenData.text" @set-phone-number="setPhoneNumber"></MultiFactorPhoneNumber>
            <MultiFactorEmailAddress v-else :labels="screenData.text" @set-email-address="setEmailAddress"></MultiFactorEmailAddress>
            <ActionList :actions="screenData.actions" @add-method="addMethod" @cancel-add-method="cancel"></ActionList>
        </div>
    </div>
</template>

<script>
    import { nextTick } from 'vue'
    import Error from '../entities/Error.vue';
    import MultiFactorPhoneNumber from '../entities/MultiFactorPhoneNumber.vue';
    import MultiFactorEmailAddress from '../entities/MultiFactorEmailAddress.vue';
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';

    export default {
        name: "MultiFactorEnroll",

        components: {
            Error,
            MultiFactorPhoneNumber,
            MultiFactorEmailAddress,
            ActionList,
            PageHeader
        },

        props: {
            screenData: Object
        },

        data: function() {
            return {
                flow: "",
                stateToken: "",
                addAPI: "",
                active: false,
                deliveryMethod: "1",
                phoneNumber: "",
                emailAddress: "",
                isValid: false,
                securityProfileRiskAuditEnabled: RESOURSE_PROPERTIES.securityProfileRiskAuditEnabled
            }
        },

        methods: {
            show: function(data) {
                this.flow = data.flow;
                this.stateToken = data.stateToken;
                this.addAPI = data.addAPI
                this.active = true;
                nextTick(function() {
                    this.$emitter.emit('disable','add-method');
                }.bind(this));
            },

            hide: function() {
                this.active = false;
            },

            submitAddMethod: function() {
                if (this.isValid) {
                    this.addMethod();
                }
            },

            riskAnalysisOfDeliveryMethod: function() {
                this.$emitter.emit('start-loading','add-method');
                const self = this;
                var API = `/BFWeb/cwapi/${this.getClient()}/authn/analyze-risk`;
                const phoneNumber = this.deliveryMethod === '1' ? this.phoneNumber : "";
                const emailAddress = this.deliveryMethod !== '1' ? this.emailAddress : "";
                var data = { 
                        "userEvent": "new_profile", 
                        "phoneNumber": phoneNumber, 
                        "emailAddress": emailAddress
                }
                self.$axios.post(API, data).then(function(response){
                    if (response.data.success) {
                        if (response.data.data.recommendedAction === "ALLOW" || response.data.data.recommendedAction === "CHALLENGE") {
                            self.sendOtp();
                        } else if (response.data.data.recommendedAction === "DENY") {
                            if (response.data.errors.length > 0) {
                                var err = response.data.errors[0];
                                var data = {
                                    flow: self.screenData.text.flow,
                                    errorCode: err.errorCode
                                };
                                self.$emitter.emit('navigate', {
                                    componentName: 'accountHold',
                                    routeData: data
                                }); 
                            }
                        }
                    }
                    else if(response.data.errors.length > 0){
                        var err = response.data.errors[0];
                        var data = {
                                    flow: self.screenData.text.flow,
                                    errorCode: err.errorCode
                                };
                        if (err.errorCode === 'XA586231') {
                             self.$emitter.emit('navigate', {
                                componentName: 'accountHold',
                                routeData: data
                            }); 
                        }
                        else if(err.errorCode === '1524'){
                            this.logout();
                        }
                        else{
                            self.$refs["error"].display(err.errorCode, err.errorMessage, err.errorType);
                        }
                    }
                    }).catch(function(error) {
                        if (typeof error.response.data == 'string' || error.response.data.errors.length > 0) {
                        var err = typeof error.response.data == 'string' ? {
                                errorCode: error.response.status,
                                errorMessage: error.message
                            } : error.response.data.errors[0];
                        self.$refs["error"].display(err.errorCode, err.errorMessage, err.errorType);
                        }
                         self.$emitter.emit('stop-loading', 'add-method'); 
                    });
            },

             addMethod: function() {
                if(this.securityProfileRiskAuditEnabled === "true" || this.securityProfileRiskAuditEnabled === true ){
                    this.riskAnalysisOfDeliveryMethod();
                }
                else
                {
                   this.sendOtp();
                }
            },

            sendOtp: function() {
                this.$emitter.emit('start-loading','add-method');
                this.$refs["error"].clear();

                var data = {
                    stateToken: this.stateToken,
                    contact: {
                        deliveryMethodType: this.deliveryMethod,
                        deliveryMethodValue: this.isMobileMethod ? this.phoneNumber : this.emailAddress
                    }
                };

                this.$axios.post(this.addAPI, data).then(function(response) {
                    if (response.data.success) {
                        var data = {
                            flow: this.flow,
                            stateToken: response.data.data.stateToken,
                            verifyTokenUrl: response.data.data._links.next.href,
                            resendTokenUrl: response.data.data._links.resend.href,
                            cancelUrl: response.data.data._links.cancel.href,
                            timeRemaining: response.data.data._links.next.timeRemainInSeconds,
                            hideChangeDeliveryMethod: true
                        };

                        this.$emitter.emit('navigate', { componentName: 'mfaVerify', routeData: data});
                        this.$emitter.emit('stop-loading','add-method');
                    }
                    else {
                        var err = response.data.messages[0];
                        if (err.errorCode === "1526") {
                            var data = {
                                flow: this.flow,
                                links: response.data.data._links,
                                noBSL: false
                            };
                            this.$emitter.emit('stop-loading','add-method');
                            this.$emitter.emit('navigate', { componentName: 'skipMfa', routeData: data});
                        }
                    }
                }.bind(this)).catch(function(error) {
                    if (typeof error.response.data == 'string' || error.response.data.messages.length > 0) {
                        var err = typeof error.response.data == 'string' ? {
                                errorCode: error.response.status,
                                errorMessage: error.message
                            } : error.response.data.messages[0];
                        this.$refs["error"].display(err.errorCode, err.errorMessage, err.errorType);
                    }
                }.bind(this));
            },

            cancel: function() {
                this.$emitter.emit('start-loading','cancel-add-method');
                window.location.href = window.location.href;
            },

            setPhoneNumber: function(val) {
                this.phoneNumber = val;
            },

            setEmailAddress: function(val) {
                this.emailAddress = val;
            },

            logout: function() {
                this.$emitter.emit('start-loading','cancel-add-method');
                window.location.href = "logOut";
            }
        },

        computed: {
            isMobileMethod: function() {
                return this.deliveryMethod === "1";
            },
            title: function() {
                return this.flow + ": " + this.screenData.text.cardTitle;
            }
        },

        watch: {
            deliveryMethod: function(val) {
                this.phoneNumber = "";
                this.emailAddress = "";
                this.isValid = false;
            },

            phoneNumber: function(val) {
                this.isValid = val !== "";
            },

            emailAddress: function(val) {
                this.isValid = val !== "";
            },

            isValid: function(val) {
                this.$emitter.emit(val ? 'enable' : 'disable', 'add-method');
            }
        },

        inject: [
            'getClient'
        ]
    }
</script>